import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from 'redux/actions/index';

import './AddExtensionModal.scss';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';
import { Modal } from 'react-bootstrap';
import { getBrowserType } from 'helpers';
import Checkbox from 'components/elements/atoms/Checkbox';
import moment from 'moment';
import { Link } from 'react-router-dom';

const REACT_APP_CHROME_EXTENSION_URL =
  process.env.REACT_APP_CHROME_EXTENSION_URL;
const REACT_APP_SAFARI_EXTENSION_URL =
  process.env.REACT_APP_SAFARI_EXTENSION_URL;
const REACT_APP_FIREFOX_EXTENSION_URL =
  process.env.REACT_APP_FIREFOX_EXTENSION_URL;
const REACT_APP_EDGE_EXTENSION_URL = process.env.REACT_APP_EDGE_EXTENSION_URL;

function AddExtensionModal({ user, actions }) {
  const [show, setShow] = useState(true);
  const [suppressWarning, setSuppressWarning] = useState(false);

  async function closeModal() {
    try {
      await actions.suppressAddExtensionWarning();
    } catch (error) {
      console.error(error);
    }
  }

  function onClose() {
    setShow(false);

    if (suppressWarning) {
      closeModal();
    }
  }

  if (!show) {
    return null;
  }

  if (
    !user ||
    !user.profile ||
    user.profile.addExtensionWarningSuppressed ||
    user.profile.gettingStartedStatus !== 'finished'
  ) {
    return null;
  }

  const browserType = getBrowserType();

  console.log('browserType', browserType);

  const noExtension =
    !user.siteInfo ||
    !Array.isArray(user.siteInfo.extensions) ||
    user.siteInfo.extensions.length === 0;

  if (noExtension) {
    return (
      <Modal show={show} className="add-extension-modal">
        <Modal.Header
          closeButton
          onHide={() => {
            onClose();
          }}
        >
          <Modal.Title>Add Extension</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-2">
            It looks like you haven’t installed the browser extension.
          </div>
          <div className="mb-2">You’ll need the extension to</div>
          <ul className="mb-2">
            <li>Get credit for reading articles</li>
            <li>
              Question, review, save, and evidence to claims on real websites
            </li>
            <li>Take quizzes</li>
            <li>Build your vocabulary</li>
          </ul>
          <div className="mb-2 mt-4">
            <Checkbox
              checked={suppressWarning}
              onClick={(e) => {
                e.preventDefault();
                setSuppressWarning((suppressWarning) => !suppressWarning);
              }}
              onChange={(e) => {}}
            >
              Don't show this again
            </Checkbox>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center">
            <RectangularButton
              className="red"
              darkButton
              onClick={() => onClose()}
            >
              Maybe later
            </RectangularButton>
            <RectangularButton
              className="green ml-2"
              darkButton
              onClick={() => {
                let url;

                if (browserType.isChrome) {
                  url = REACT_APP_CHROME_EXTENSION_URL;
                } else if (browserType.isFirefox) {
                  url = REACT_APP_FIREFOX_EXTENSION_URL;
                } else if (browserType.isSafari) {
                  url = REACT_APP_SAFARI_EXTENSION_URL;
                } else if (browserType.isEdge) {
                  url = REACT_APP_EDGE_EXTENSION_URL;
                }

                if (!url) {
                  return;
                }

                window.open(url, '_blank');
              }}
            >
              Get the extension now
            </RectangularButton>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  // Determine current browser name as a string
  let currentBrowser;
  if (browserType.isChrome) currentBrowser = 'CHROME';
  else if (browserType.isFirefox) currentBrowser = 'FIREFOX';
  else if (browserType.isSafari) currentBrowser = 'SAFARI';
  else if (browserType.isEdge) currentBrowser = 'EDGE';
  else if (browserType.isOpera) currentBrowser = 'OPERA';
  else currentBrowser = null;

  console.log('currentBrowser', currentBrowser);

  if (!currentBrowser) {
    return null;
  }

  const extensions = user.siteInfo.extensions || [];

  // Filter only extensions matching current browser
  const currentBrowserExtensions = extensions.filter(
    (ext) => ext.browser === currentBrowser,
  );

  console.log('currentBrowserExtensions', currentBrowserExtensions);

  if (currentBrowserExtensions.length === 0) {
    return null;
  }

  const latestExtensions = currentBrowserExtensions.sort((ext2, ext1) => {
    return moment(ext2.time).isAfter(ext1.time) ? -1 : 1;
  });
  const isInstalled = latestExtensions.filter(
    (ext) =>
      ext &&
      ext.installed &&
      ext.installed.time &&
      (!ext.installed.uninstallTime ||
        moment(ext.installed.uninstallTime).isBefore(ext.installed.time)),
  );
  const isLoggedIn = latestExtensions.filter(
    (ext) =>
      ext &&
      ext.login &&
      ext.login.time &&
      (!ext.login.loggedOutTime ||
        moment(ext.login.loggedOutTime).isBefore(ext.login.time)),
  );
  const isPinnedIn = latestExtensions.filter(
    (ext) =>
      ext &&
      ext.pinned &&
      ext.pinned.time &&
      (!ext.pinned.unpinnedTime ||
        moment(ext.pinned.unpinnedTime).isBefore(ext.pinned.time)),
  );

  if (
    isInstalled.length > 0 &&
    isLoggedIn.length > 0 &&
    isPinnedIn.length > 0
  ) {
    return null;
  }

  function showReason() {
    if (isInstalled.length === 0) {
      return 'On our end, it looks like you didn’t install the extension or uninstalled it.';
    } else if (isLoggedIn.length === 0) {
      return (
        <span>
          On our end, it looks like you aren’t logged in. To log in, click the
          white AverPoint button on your browser. If you don’t see it, you’ll
          need to first{' '}
          <Link to="/help-page?helpId=679a5b40d0617161e7c7b1fb">pin</Link> the
          extension to your browser.
        </span>
      );
    } else if (isPinnedIn.length === 0) {
      return 'On our end, it looks like you haven’t pinned the extension to your browser';
    }
  }

  function showActions() {
    if (isInstalled.length === 0) {
      return (
        <RectangularButton
          className="green ml-2"
          darkButton
          onClick={() => {
            const browserType = getBrowserType();

            let url;

            if (browserType.isChrome) {
              url = REACT_APP_CHROME_EXTENSION_URL;
            } else if (browserType.isFirefox) {
              url = REACT_APP_FIREFOX_EXTENSION_URL;
            } else if (browserType.isSafari) {
              url = REACT_APP_SAFARI_EXTENSION_URL;
            } else if (browserType.isEdge) {
              url = REACT_APP_EDGE_EXTENSION_URL;
            }

            if (!url) {
              return;
            }

            window.open(url, '_blank');
          }}
        >
          Get the extension now
        </RectangularButton>
      );
    }

    return null;
  }

  function showHelp() {
    if (isInstalled.length === 0) {
      return null;
    }

    if (isLoggedIn.length === 0) {
      return (
        <div className="text-center my-4">
          <img src="https://res.cloudinary.com/averpoint/image/upload/v1714546048/averpoint_extension_-_login_ct2y5d.gif" />
        </div>
      );
    }

    if (isPinnedIn.length === 0) {
      return (
        <>
          <div className="mb-2">
            To pin the extension, click on the puzzle icon. You’ll see a list of
            all the extensions on your browser. Click on the pin icon next to
            the AverPoint extension to pin it.
          </div>
          <div className="text-center my-4">
            <img src="https://res.cloudinary.com/averpoint/image/upload/v1714546047/pin_and_login_ednr7p.gif" />
          </div>
        </>
      );
    }

    return null;
  }

  return (
    <Modal show={show} className="add-extension-modal">
      <Modal.Header
        closeButton
        onHide={() => {
          onClose();
        }}
      >
        <Modal.Title>Add Extension</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-2">Your extension isn’t working.</div>
        <div className="mb-2">{showReason()}</div>
        {showHelp()}
        <div className="mb-2 mt-4">
          <Checkbox
            checked={suppressWarning}
            onClick={(e) => {
              e.preventDefault();
              setSuppressWarning((suppressWarning) => !suppressWarning);
            }}
            onChange={(e) => {}}
          >
            Don't show this again
          </Checkbox>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-center">
          <RectangularButton
            className="red"
            darkButton
            onClick={() => onClose()}
          >
            Maybe later
          </RectangularButton>
          {showActions()}
        </div>
      </Modal.Footer>
    </Modal>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.user ? state.user.user : null,
  };
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(Actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddExtensionModal);
